module.exports = __webpack_public_path__ + "static/InsuranceGraphic-0e7b9fa33cc7ae7d937b35fd6b483171.svg";